export default __webpack_public_path__ + "static/media/u_x.32057973.svg";